<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 23V1" stroke="#130F26" stroke-width="2" stroke-linecap="round"/>
        <path d="M0.999999 12L23 12" stroke="#130F26" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>

<script>
    export default {
        name: "PlusIcon"
    }
</script>

<style scoped>

</style>